
export const CollectionStrings = {
    EMPLOYEES: 'Employees',
    COURSES: 'Courses',
    COMPANIES: 'Companies',
    MANAGERS: 'Managers',
    CONTACTUS: "ContactUs",
    COURSELOCATION: "CourseLocations",
    ORDERS: "Orders"
}